import { IAppState } from "./App";
import { OptionsType } from "./CommonTypes";
import { SerializedTool } from "./components/measure_tools/Creator";

export type AppHistoryState = (Omit<IAppState, 'panelCollapsed' | 'interacting' | 'showSave' | 'showAbout' | 'showImageChooser' | 'measurements' | 'justNavigated' | 'showQuickInstruction'> & {
  measurementsData: SerializedTool[];
  windowTitle: string;
  scrollOffset: { x: number, y: number };
});

export type AppHistoryEntry = {
  opts?: OptionsType;
  data?: AppHistoryState;
} 

export type HistSaveListener = (entry: AppHistoryEntry, createNew: boolean) => void;
export type HistRestoreListener = (entry: AppHistoryEntry) => void;

class AppHistory {
  private saveListeners: HistSaveListener[] = [];
  private restoreListeners: HistRestoreListener[] = [];


  private add = <T>(data: T, list: T[]) => {
    list.push(data);
  };

  private remove = <T>(data: T, list: T[]) => {
    const idx = list.indexOf(data);
    if (idx) {
      list.splice(idx, 1);
    }
  };

  public addSaveListener = (listener: HistSaveListener) => this.add(listener, this.saveListeners);

  public removeSaveListener = (listener: HistSaveListener) => this.remove(listener, this.saveListeners);

  public addRestoreListener = (listener: HistRestoreListener) => this.add(listener, this.restoreListeners);

  public removeRestoreListener = (listener: HistRestoreListener) => this.remove(listener, this.restoreListeners);

  public save = (state: AppHistoryEntry, createNew: boolean) => {
    for (const listener of this.saveListeners) {
      listener(state, createNew);
    }
  };

  public restore = (entry: AppHistoryEntry) => {
    for (const listener of this.restoreListeners) {
      listener(entry);
    }
  };

  public getCurrent: () => AppHistoryEntry = () => ({ });
};

export const appHistory = new AppHistory();